import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Logo from '../components/Logo';

const Cookies: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 py-12">
        <div className="mb-8">
          <Link to="/" className="inline-flex items-center text-gray-600 hover:text-gray-900">
            <ArrowLeft className="w-5 h-5 mr-2" />
            Back to Home
          </Link>
        </div>
        
        <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12">
          <div className="flex justify-center mb-8">
            <Logo />
          </div>

          <h1 className="text-3xl font-bold mb-8 text-center">Cookie Policy</h1>
          
          <div className="space-y-8">
            <section>
              <h2 className="text-xl font-semibold mb-3">What Are Cookies</h2>
              <p className="text-gray-600">
                Cookies are small text files that are stored on your computer or mobile device when you visit our website. They allow us to recognize your device and remember certain information about your visit, such as your preferences and actions on our site.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">How We Use Cookies</h2>
              <p className="text-gray-600">SmartiStat uses cookies for the following purposes:</p>
              <ul className="list-disc list-inside space-y-2 text-gray-600 mt-3 ml-4">
                <li>Essential Cookies: Required for basic website functionality and security. These cannot be disabled.</li>
                <li>Performance Cookies: Help us understand how visitors interact with our website by collecting anonymous information.</li>
                <li>Functional Cookies: Remember your preferences to provide enhanced, personalized features.</li>
                <li>Analytics Cookies: Track website usage to help us measure and improve site performance.</li>
                <li>Authentication Cookies: Maintain your logged-in status as you navigate through our platform.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">Cookie Categories</h2>
              <div className="space-y-4">
                <div>
                  <h3 className="font-medium mb-2">First-Party Cookies</h3>
                  <p className="text-gray-600">
                    These cookies are set by SmartiStat directly and are necessary for the operation of our site and services.
                  </p>
                </div>
                <div>
                  <h3 className="font-medium mb-2">Third-Party Cookies</h3>
                  <p className="text-gray-600">
                    We use limited third-party cookies for analytics and performance monitoring. These include:
                  </p>
                  <ul className="list-disc list-inside space-y-2 text-gray-600 mt-2 ml-4">
                    <li>Google Analytics (for website usage tracking)</li>
                    <li>Hotjar (for user experience analysis)</li>
                  </ul>
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">Your Cookie Choices</h2>
              <p className="text-gray-600">
                When you first visit our website, you will be prompted to accept or decline non-essential cookies. You can change your preferences at any time by clicking the "Cookie Settings" link in the website footer.
              </p>
              <p className="text-gray-600 mt-3">
                Most web browsers allow you to control cookies through their settings. Please note that restricting cookies may impact your experience and the functionality of our website.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">Healthcare Considerations</h2>
              <p className="text-gray-600">
                As a healthcare technology provider, we ensure all cookie usage complies with relevant healthcare privacy regulations, including HIPAA. No protected health information (PHI) is ever stored in cookies.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">Updates to This Policy</h2>
              <p className="text-gray-600">
                This Cookie Policy may be updated periodically to reflect changes in our practices or regulatory requirements. The latest version will always be available on our website.
              </p>
            </section>

            <div className="text-sm text-gray-500 pt-8 border-t">
              Last Updated: May 4, 2025
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Cookies;